/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "../../base/colors.js";
import borders from "../../base/borders.js";

// Material Dashboard 2 PRO React Helper Function
import rgba from "../../functions/rgba.js";

const { white, dark } = colors;
const { borderWidth, borderRadius } = borders;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: white.main,
      backgroundClip: "border-box",
      border: `${borderWidth[1]} solid ${rgba(dark.main, 0.06)}`,
      borderRadius: borderRadius.xxl,
      boxShadow: `0 1px 2px ${rgba(dark.main, 0.04)}, 0 10px 30px -14px ${rgba(
        dark.main,
        0.22
      )}`,
      overflow: "hidden",
      transition:
        "box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), transform 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms ease",
    },
  },
};

export default card;
